import { anyPass, pipe, test } from 'ramda'

export default anyPass([
  pipe(String, test(/React./)),
  pipe(String, test(/react./)),
  pipe(String, test(/.createElement/)),
  pipe(String, test(/StyledComponent/)),
])
